module.exports = __webpack_public_path__ + "static/img/showroom03.37b38c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/showroom03.jpg
// module id = uAby
// module chunks = 0